export default "__VITE_ASSET__DiOgdgS6__"